import { render, staticRenderFns } from "./MoleculeEditionAccountNotifications.vue?vue&type=template&id=1efc8808"
import script from "./MoleculeEditionAccountNotifications.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionAccountNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports